import React, { useState } from 'react';
import { UserLocale } from '@teetsh/app/src/types/user';
import { useFormState } from 'react-final-form';
import { useSendUpdateParamsToIframe } from 'components/Iframe/useSendUpdateParamsToIframe';
import { buildCdnParams } from 'containers/CarnetsDeNotes/Preview/Sidebar/buildCdnParams';
import { IframePreviewPDF } from 'components/Print/IframePreviewPDF';
import { useSchoolSchoolyear } from 'containers/App/context/SchoolyearSchoolProvider';
import { GroupBy } from 'containers/CarnetsDeNotes/CarnetDetails/types';
import { CarnetDeNotesPdfSettings } from '../types/carnetsDeNotes';

interface Props {
  cdnId: string;
  userId: string;
  lng: UserLocale;
  groupBy: GroupBy;
}

export function Body(props: Props) {
  const { schoolyear, school } = useSchoolSchoolyear();
  const { cdnId, groupBy, lng } = props;
  const { values: settings } = useFormState<CarnetDeNotesPdfSettings>();

  const url = new URL(
    `/print/annee-scolaire/${schoolyear.id}/ecole/${school.id}/carnets-de-notes/${cdnId}`,
    window.location.origin,
  );

  url.search = buildCdnParams({
    lng,
    settings,
    groupBy,
  }).toString();

  const [urlAsString] = useState(url.toString());

  const { iframeRef } = useSendUpdateParamsToIframe({
    url,
    search: buildCdnParams({
      lng,
      settings,
      groupBy,
    }),
  });

  return (
    <IframePreviewPDF
      iframeUrl={urlAsString}
      iframeRef={iframeRef}
      landscape={settings.landscape}
    />
  );
}
